
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"quicklinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quicklink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":72}};
    doc.loc.source = {"body":"fragment quicklinkFields on Quicklink {\n  id\n  title\n  url\n  category\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/quicklinkFields.graphql
// module id = 62
// module chunks = 17